<template>
  <div class="page-wrapper state5">
    <el-header class="page-header">
      <div class="table-header-box">
        <div class="section-title">课堂练习</div>
        <el-input
          v-model="searchQuery"
          placeholder="搜索名称..."
          prefix-icon="el-icon-search"
          class="search-input"
          clearable
        ></el-input>
      </div>
    </el-header>

    <el-main class="page-main">
      <div class="table-container">
        <el-table
          v-loading="loading"
          element-loading-text="正在加载数据..."
          :data="filteredWorkList"
          style="width: 100%"
          height="100%"
          :row-class-name="getCellIndex"
          highlight-current-row
          stripe
          :border="false"
          :header-cell-style="{
            background: '#f8fafc',
            color: '#475569',
            fontWeight: 'bold'
          }"
        >
          <el-table-column label="名称" min-width="200">
            <template slot-scope="scope">
              <span> {{ scope.row.teachingTask.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="180">
            <template slot-scope="scope">
              <span> {{ scope.row.teachingTask.createTime }}</span>
            </template>
          </el-table-column>

          <el-table-column label="正确率" min-width="120" align="center">
            <template slot-scope="scope">
              <span class="accuracy-text">{{
                scope.row.teachingTaskStudent.objectiveCorrectRate + "%"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="120" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.teachingTaskStudent.taskStudentState === 1">
                <span class="status-tag status-primary">答题中</span>
              </div>
              <div
                v-else-if="
                  [2, 4].includes(
                    scope.row.teachingTaskStudent.taskStudentState
                  )
                "
              >
                <span class="status-tag status-success">已提交</span>
              </div>
              <div
                v-else-if="scope.row.teachingTaskStudent.taskStudentState === 3"
              >
                <span class="status-tag status-success">已完成</span>
              </div>
              <div v-else>
                <span class="status-tag status-error">缺交</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.teachingTaskStudent.taskStudentState === 1"
                size="mini"
                type="primary"
                @click="beginWorkLisk(scope.row)"
                >开始练习</el-button
              >
              <el-button
                v-else-if="
                  [2, 3, 4].includes(
                    scope.row.teachingTaskStudent.taskStudentState
                  )
                "
                size="mini"
                class="analysis-btn"
                @click="getworkList(scope.row)"
                >查看解析</el-button
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <el-empty description="暂无课堂练习"></el-empty>
          </template>
        </el-table>
      </div>
    </el-main>
  </div>
</template>

<script>
import { getOwnTaskList, getOwnTeachingTaskDetail } from "@/api/student";
export default {
  name: "PracticeIndex",
  components: {},
  data() {
    return {
      workList: [],
      searchQuery: "",
      loading: false
    };
  },
  computed: {
    filteredWorkList() {
      if (!this.searchQuery) return this.workList || [];
      return (this.workList || []).filter(
        item =>
          item.teachingTask &&
          item.teachingTask.name &&
          item.teachingTask.name
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase())
      );
    }
  },
  mounted() {
    this.loadWorkList();
  },
  methods: {
    async loadWorkList() {
      this.loading = true;
      let data = {
        type: 1,
        studentId: JSON.parse(localStorage.getItem("userInfo")).studentId
      };
      this.workList = [];
      await getOwnTaskList(data)
        .then(res => {
          let List = res.data || [];
          List.map(val => {
            val.teachingTaskStudentInfos.map(item => {
              item.teachingTaskStudent.objectiveCorrectRate = (
                item.teachingTaskStudent.objectiveCorrectRate * 100
              ).toFixed(2);
              this.workList.push(item);
            });
          });
          this.workList.sort((a, b) => {
            return b.teachingTask.id - a.teachingTask.id;
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getCellIndex({ row, rowIndex }) {
      row.index = rowIndex;
      if (row.score != "") {
        return "success-row";
      } else {
        return "warning-row";
      }
    },
    async beginWorkLisk(row) {
      let params = {
        studentId: row.teachingTaskStudent.studentId,
        taskId: row.teachingTask.id
      };
      localStorage.setItem("taskId", row.teachingTask.id);
      await getOwnTeachingTaskDetail(params).then(res => {
        if (res.code == 200) {
          localStorage.setItem("workquestion", JSON.stringify(res.data));
        }
        this.$router.push({
          path: `/workTest/${row.teachingTask.id}`,
          query: {
            title: row.teachingTask.name,
            analysis: 0
          }
        });
      });
    },
    getworkList(row) {
      this.$router.push({
        path: `/workhistory/${row.teachingTask.id}`,
        query: { title: row.teachingTask.name, analysis: 1 }
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/examination-page.scss";

.page-wrapper {
  background-color: #f5f7fa;
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
}

.page-header {
  background: #fff;
  border-radius: 8px;
  padding: 16px 24px;
  margin-bottom: 16px;
  height: auto !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}

.page-main {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.table-container {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.table-header-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-input {
  width: 400px;
}

.status-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;

  &.status-success {
    background: #f0fdf4;
    color: #16a34a;
  }

  &.status-primary {
    background: #eff6ff;
    color: #2563eb;
  }

  &.status-error {
    background: #fef2f2;
    color: #dc2626;
  }

  &.status-info {
    background: #f8fafc;
    color: #94a3b8;
  }
}

.accuracy-text {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  color: #2563eb;
}
</style>
